<div class="influencer-auto-suggest d-flex flex-row flex-auto" [ngClass]="{'top': numberSelectedInfluencer > 2}">
  <div class="add-icon d-flex">
    <img src="/assets/images/Plus_Dark.svg" class="add-more-influencer-icon">
  </div>
  <div class="d-flex flex-auto">
    <ng-select #ngSelectAutoSuggestionBox [items]="suggestionInfluencers"
               [virtualScroll]="true"
               class="d-flex flex-auto"
               [typeahead]="typeahead"
               [loading]="suggestionLoading"
               bindValue="id"
               bindLabel="name"
               [typeToSearchText]="''"
               [(ngModel)]="selectedInfluencer"
               (scroll)="onScroll($event)"
               (scrollToEnd)="onScrollEnd()">
      <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <achoo-loader [facebookPlaceholder]="false"
                        [normalPlaceholder]="true"
                        class="partial-placeholder">
          </achoo-loader>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="auto-selection-container" (click)="onSelectSuggestion(item)" [ngClass]="{'new-project-line': item.id === 0, 'odd': index % 2 !== 0, 'even': index % 2 === 0}">
          <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12">
              <div class="d-flex flex-row flex-nowrap flex-auto">
                <div class="profile-image-container">
                  <achoo-user-avatar [showCountryFlagIcon]="true"
                                     [userAvatarPicture]="item.profilePicture"
                                     [userCountryCode]="getCountryCode(item)"
                                     [avatarHeight]="3.125"
                                     [avatarWidth]="3.125"
                                     [countryHeight]="1.25"
                                     [countryWidth]="1.25"
                  ></achoo-user-avatar>
                </div>
                <div class="d-flex flex-column ml-3 ellipsis">
                  <div class="influencer-personal-info d-flex flex-row">
                    <div class="flag-icon-background flag-icon-{{getCountryCode(item)}} flag-icon-squared img-circle"></div>
                    <span class="influencer-name">{{item.influencerName}}</span>
                  </div>
                  <div class="influencer-suggestion-kpi d-flex flex-row">
                    <div class="kpi-content">{{item.country.name}}</div> |
                    <div class="kpi-content">{{'group_details.suggestion_influencer_posts' | translate:{numOfPost: item.numberOfPosts | formatNumberToString} }}</div> |
                    <div class="kpi-content">{{'group_details.suggestion_influencer_followers' | translate:{numOfFollower: item.numberOfFollowers | thousandNumberSuffix} }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12">
              <div class="d-flex flex-row">
                <div *ngFor="let platform of platformList" class="platform-icon-wrapper">
                  <div class="{{platform.name.toLowerCase() + '-icon'}}" [ngClass]="{'disabled-icon': !hasPlatform(platform.id, item)}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="d-flex flex-row align-items-center ng-option disabled"
             actionByLevels="Create Campaign"
             [wallName]="'Add New Influencer Manually Disabled'"
             (afterChecking)="addNewInfluencerManually()">
          <span class="d-flex flex-auto">{{'common.not_found_influencer' | translate}}</span>
          <button class="button add-now-btn blue" actionByLevels="Create Campaign" (afterChecking)="addNewInfluencerManually()">
            {{'common.btn.add_now' | translate}}
          </button>
        </div>
      </ng-template>
      <ng-template ng-footer-tmp *ngIf="canShowAddNewInfluencerLine">
        <div class="d-flex flex-row align-items-center ng-option disabled"
             actionByLevels="Create Campaign"
             [wallName]="'Add New Influencer Manually Disabled'"
             (afterChecking)="addNewInfluencerManually()">
          <span class="d-flex flex-auto">{{'common.add_manually_influencer' | translate}}</span>
          <button class="button add-now-btn blue" actionByLevels="Create Campaign" (afterChecking)="addNewInfluencerManually()">
            {{'common.btn.add_now' | translate}}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/auto-suggestion-influencer/auto-suggestion-influencer.component.html